import { RaisedHands, STATE_ACTIVATED, STATE_ANIMATE, STATE_IDLE } from '@bnnvara/icons/src/components/AnimatedIcons/RaisedHands/RaisedHands';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import * as S from './styled';

const LikeButton = ({
  likes,
  isLiked,
  onClick,
  disabled
}) => {
  const [likeState, setLikeState] = useState(isLiked ? STATE_ACTIVATED : STATE_IDLE);
  useEffect(() => {
    if (isLiked) {
      setLikeState(STATE_ANIMATE);
      return;
    }

    setLikeState(STATE_IDLE);
  }, [isLiked]);
  return /*#__PURE__*/React.createElement(S.LikeButton, {
    onClick: onClick,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(RaisedHands, {
    state: likeState
  }), likes > 0 && /*#__PURE__*/React.createElement(S.AmountLikes, null, " ", likes, " "));
};

LikeButton.propTypes = {
  isLiked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  likes: PropTypes.number,
  disabled: PropTypes.bool
};
LikeButton.defaultProps = {
  likes: null,
  disabled: false
};
export default LikeButton;